export default __webpack_public_path__ + "static/2024-img-articolo-dicembre2-225ebabb1f30cbb0a27bd6da757d0c63.jpg";